const enterTimeButton = document.querySelector('[data-virtual-id]');
enterTimeButton?.addEventListener('click', (e) => {
  const url = new URL(e.target.href);
  const vrId = url.searchParams.get('vrId');
  if (vrId) {
    localStorage.setItem('selectedProduct', vrId);
  }
});

const downloadButtons = document.querySelectorAll('[data-download-card]');
downloadButtons.forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();
        const pdfUrl = this.getAttribute('data-download-file');
        if (!pdfUrl) return;
        window.open(pdfUrl, '_blank');
    });
});
